import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { EnquiryProvider } from "@/context/EnquiryContext";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import Results from "@/pages/Results";
import Gallery from "@/pages/Gallery";
import Videos from "@/pages/Videos";
import Contact from "@/pages/Contact";
import ConfirmFees from "@/pages/ConfirmFees";
import Admission from "@/pages/Admission";
import PayFees from "@/pages/PayFees";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/admin/AdminLogin";
import OwnerLogin from "@/pages/owner/OwnerLogin";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";

import RoleRoute from "@/pages/star/RoleRoute";
import StudentLogin from "@/pages/star/StudentLogin";
import StudentForgotPassword from "@/pages/star/StudentForgotPassword";
import StudentResetPassword from "@/pages/star/StudentResetPassword";
import StudentActivate from "@/pages/star/StudentActivate";
import StudentActivateVerify from "@/pages/star/StudentActivateVerify";
import StudentOnboarding from "@/pages/star/StudentOnboarding";
import AdminActivations from "@/pages/admin/AdminActivations";
import StudentRegister from "@/pages/star/StudentRegister";
import StudentDashboard from "@/pages/star/StudentDashboard";
import TeacherLogin from "@/pages/star/TeacherLogin";
import TeacherDashboard from "@/pages/star/TeacherDashboard";
import AttendanceScan from "@/pages/star/AttendanceScan";

function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <EnquiryProvider>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/results" element={<Results />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/pay-fees" element={<PayFees />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
              </Route>

              {/* Star System — Students */}
              <Route path="/confirm-fees" element={<ConfirmFees />} />
              <Route path="/admission" element={<Admission />} />
              <Route path="/student/login" element={<StudentLogin />} />
              <Route path="/student/forgot-password" element={<StudentForgotPassword />} />
              <Route path="/student/reset-password" element={<StudentResetPassword />} />
              <Route path="/student/register" element={<StudentRegister />} />
              <Route path="/student/activate" element={<StudentActivate />} />
              <Route path="/student/activate/verify" element={<StudentActivateVerify />} />
              <Route path="/student/onboarding" element={<RoleRoute roles={["student"]} redirect="/student/login"><StudentOnboarding /></RoleRoute>} />
              <Route path="/student" element={<RoleRoute roles={["student"]} redirect="/student/login"><StudentDashboard /></RoleRoute>} />

              {/* Star System — Teachers */}
              <Route path="/teacher/login" element={<TeacherLogin />} />
              <Route path="/teacher" element={<RoleRoute roles={["teacher", "admin"]} redirect="/teacher/login"><TeacherDashboard /></RoleRoute>} />
              <Route path="/attendance" element={<AttendanceScan />} />

              {/* Admin */}
              <Route path="/entrepreneur/login" element={<OwnerLogin />} />
              <Route path="/entrepreneur" element={<OwnerDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/activations" element={<ProtectedRoute><AdminActivations /></ProtectedRoute>} />
            </Routes>
          </EnquiryProvider>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </SiteProvider>
  );
}

export default App;
